(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee-images"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', (event) => {
    Marquee3k.init({
        selector: 'marquees'
    });
});


  } catch(e) { console.error(e); }
})();
})();
